import React from "react";

const PageLoader = () => (
  <div
    className="flex items-center justify-center min-h-[50vh]"
    role="status"
    aria-label="Loading page"
  >
    <div className="w-8 h-8 border-2 border-[#223bac]/20 border-t-[#223bac] rounded-full animate-spin" />
  </div>
);

export default PageLoader;
